import {useTranslation} from 'react-i18next';
import {Link, useNavigate} from 'react-router-dom';
import {Button} from 'antd';

import Layout from '../../components/Layout/Layout';
import {LOGIN, POLICY} from '../../config/routes';

import bg from './bg.jpg'

import cls from './Splash.module.scss'

export const Splash = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    const footer = (
        <footer className={cls.footer}>
            <div>
                <Button onClick={() => navigate(LOGIN)}>Вход</Button>
            </div>
            <div>
                <Link to={POLICY}>{t('Privacy policy')}</Link>
            </div>
        </footer>
    )

    return (
        <Layout footer={footer} bgImage={bg}>
            <div className={cls.splash}>
                <h1 className={cls.title}>vita</h1>
                <h1 className={cls.subtitle}>Управляй
                    своим
                    здоровьем
                </h1>
            </div>
        </Layout>
    )
}